import {Component, h, Fragment} from "preact";
import {connect} from "react-redux";
import '../_common/css/components/header.scss';
import Logo from '../_common/components/img/ilerna-rebranding.svg';
import {Link} from "react-router-dom";
import {fetchIsLoggedIn, logout} from "../_rx/_auth/actions";
import {t} from '../_i18n';
import {replaceHash, setClass, closeMenu} from "../_common/common";

import {withRouter} from "react-router";
import {useEffect, useState} from "preact/hooks";
import {CompanyCompany, CompanyUser} from "../_api/models";


const Links = ({ logout, appLinks}:any)=><div>
    {appLinks && appLinks.filter((link:any)=>link.className!='campus').map((link:any)=> {
        if (link.sep)
            return <hr/>
        if(link.disabled)
            return <a href="#" className="disabled-link disabled-aspect-gray">{link.text} {link.extra}</a>;
        if(link.dispatch.startsWith('https:'))
            return <a href={link.dispatch} target="_blank">{link.text}</a>;
        if(link.dispatch.startsWith('url:'))
            return <Link key={link.text} to={link.dispatch.substring(4)}>{link.text} {link.extra}</Link>;
        if(link.dispatch === 'exec:logout')
            return <a key={link.dispatch} href="#" onClick={e=>{e.preventDefault(); logout();}} className="close-sesion">{link.text} {link.extra}</a>;
    })}
</div>;


export const computeAppLinks = ()=>{
    return [
        {text: t('Datos de usuario'), dispatch:"url:/user" },
        {text: t('Perfil de empresa'), dispatch:"url:/company/edit" },
        // {text: t('Ofertas'), dispatch:"url:/offers" },
        {sep: true},
        {text: t('Cerrar sesión'), className:"logout", dispatch:"exec:logout"}
    ];
};




const HeaderWide = (props:any)=> {

    const campusLink = props.appLinks && props.appLinks.find((lnk:any) => lnk.className == 'campus');
    return <div className="d-none md-d-block">
        {/*<div class="over-header">Llamanos GRATIS <strong>900 730 222</strong></div>*/}
        <header className="menu d-flex">
            <div className="menu-item-left">
                <MenuDesktopLeft {...props} />
            </div>
            <div className="right-menu">
                <div className="menu-item-right">
                    <MenuDesktopRight {...props} />
                </div>
            </div>
        </header>
    </div>
};


const MenuDesktopLeft = (props: any) => {
    return <section className="home-logo">
        <div className="logo-container">
            <Link to='/offers'>
                <img src={Logo} alt="ILERNA" className="logo"/>
            </Link>
        </div>
    </section>
}


const MenuDesktopRight = (props: any) => {
    const [ shown, setShown ] = useState(true);
    useEffect(() => {
        function docClick(event: any) {
            if (event.path && event.path.filter((ele:any) => ele.id === 'label-menu-right').length > 0)
                return;
            if (!shown) {
                setShown(true)
            }
        }
        document.addEventListener("click", docClick);
        return () => {
            document.removeEventListener("click", docClick);
        };
    }, [shown]);



    return <section className="dropdown">
        <div className="dropdown-element">
            <label onClick={() => setShown(!shown)} id="label-menu-right">
                {/*<i className="fas fa-circle bubble fa-xs" aria-hidden="true"></i>*/}
                <i className="fal fa-user-circle fa-lg"/>
                <i className="fas fa-chevron-down fa-xs"/>
            </label>
            {!shown && <article className="right menu-handler">
                <a className="nombre-alumno">{props.company.name}</a>
                <Links {...props} />
            </article>}
        </div>
    </section>
}


const HeaderMobile = (props: any)=> {
    const campusLink = props.appLinks && props.appLinks.find((lnk:any) => lnk.className == 'campus');
    return <header className="menu-mobile d-flex md-d-none">
        <div className="left-menu">
            <div className="menu-item-left">
                {/*<i className="fas fa-circle bubble fa-xs"></i>*/}
                <PopMenu id="mainmenu" button={() =>
                    <Fragment>
                        <i className="fal fa-bars fa-lg"/>
                    </Fragment>}>
                    {props.company ?
                        <span className="nombre-alumno">{props.company.name}</span>
                        : ''
                    }
                    <Links {...props} />
                    {/*<section>*/}
                    {/*    <Fragment>*/}
                    {/*        <a target="_blank" href="https://www.ilerna.es"> ILERNA </a>*/}
                    {/*        <a target="_blank" href="https://www.ilerna.es/fp-lleida/es/"> ILERNA Lleida </a>*/}
                    {/*        <a target="_blank" href="https://www.ilerna.es/fp-madrid/"> ILERNA Madrid </a>*/}
                    {/*        <a target="_blank" href="https://www.ilerna.es/fp-sevilla/"> ILERNA Sevilla </a>*/}
                    {/*        <a target="_blank" href="https://www.ilerna.es/es/fp-a-distancia"> ILERNA Online </a>*/}
                    {/*        <a target="_blank" href="https://www.ilerna.es/es/fp-universidad"> FP+Universidad </a>*/}
                    {/*    </Fragment>*/}
                    {/*</section>*/}
                </PopMenu>
            </div>
            <Link to='/offers'>
                <div className="logo">
                    <img src={Logo} alt="ILERNA"/>
                </div>
            </Link>
        </div>
        <div className="right-menu">

        </div>
    </header>
}

type Props = {
    id: string,
    history: any,
    appLinks: any[],
};

const PopMenu : any = withRouter(class extends Component<Props,{}> {

    state = {open:location.hash.endsWith(this.props.id)};

    componentDidUpdate(){ setClass(document.body, 'modal-visible', this.state.open); }
    componentDidMount(){
        this.props.history.listen((location:any) => {
            this.setState({open:location.hash.endsWith(this.props.id)});
        });
        closeMenu();
    }

    open(){
        replaceHash(this.props.id);
        this.setState({open:true});
    }

    render({children, button}: any){
        return <Fragment>
            <label onClick={()=>this.open()} htmlFor={this.props.id}>{button()}</label>
            <article style={{display: this.state.open ? 'block':'none'}}>
                <header>
                    <span onClick={()=>history.back()}><i className="fal fa-times fa-lg" /></span>
                </header>
                {children}
            </article>
        </Fragment>;
    }

} as any);


const HeaderView: any = class extends Component {
    render(props:any) {
        return <Fragment>
            <HeaderWide {...props} />
            <HeaderMobile {...props} />
        </Fragment>
    }
}

export default connect(() => ({}),
    {
        logout,
    })(HeaderView) as any;
